/**
 * Smooth scrolling on internal links
 */

import jump from 'jump.js';

export default (document => {
    function smoothJump(event) {
        const target = event.currentTarget.hash || '#content';
        const element = document.querySelector(target);
        if (element) {
            jump(element, {
                duration: 800,
                offset: -100,
            });
        }
        event.preventDefault();
    }

    Array.from(document.querySelectorAll('[href^="#"]')).forEach(link => {
        link.addEventListener('click', smoothJump);
    });

    Array.from(document.querySelectorAll('.js-skip')).forEach(element => {
        element.addEventListener('click', event => {
            if (
                element !== event.target &&
                (event.target.tagName === 'A' ||
                    event.target.tagName === 'BUTTON' ||
                    event.target.tagName === 'B')
            ) {
                return;
            }
            smoothJump(event);
        });
    });
})(document);



// WEBPACK FOOTER //
// src/js/plugins/jumpLinks.js